import { c as _c } from "react/compiler-runtime";
import Skeleton from 'react-loading-skeleton';
import { useCssVariable } from '@shared/utils/hooks/use-css-variable';
import styles from './loader-strip.module.scss';
export const LoaderStrip = t0 => {
  const $ = _c(3);
  const {
    isSecondaryVariant
  } = t0;
  const [baseColor] = useCssVariable(isSecondaryVariant ? "--mdrt-color-backgrounds-bg-secondary-fill" : "--mdrt-color-backgrounds-bg-primary-fill-01");
  const [highlightColor] = useCssVariable("--mdrt-color-backgrounds-bg-surface");
  let t1;
  if ($[0] !== baseColor.propertyValue || $[1] !== highlightColor.propertyValue) {
    t1 = <Skeleton baseColor={baseColor.propertyValue} borderRadius={0} className={styles["loader-strip"]} containerClassName={styles["loader-strip-container"]} highlightColor={highlightColor.propertyValue} inline={false} />;
    $[0] = baseColor.propertyValue;
    $[1] = highlightColor.propertyValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};